<template>
  <v-layout v-resize="getWindowDimensions">
    <v-flex xs12>
      <BaseToolbar
        :title="$t('organization.form.title')"
        type-title="icon"
        icon="edit"
        :button-save="true"
        :loaderSave="isLoading"
        @close="closeDrawerOrg"
        @save="save"
      />
      <v-layout wrap pa-5 style="overflow-y: auto">
        <v-flex xs6>
          <v-card class="afrus-d-rounded-card mt-5">
            <v-card-title primary-title>
              <h5>
                {{ $t("organization.form.org_data") }}
              </h5>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 pr-5>
                  <v-text-field
                    v-model="name"
                    v-validate="'required'"
                    data-vv-name="name"
                    required
                    :label="$t('organization.table.org_name')"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs11 ml-3>
                  <v-text-field
                    v-model="url"
                    v-validate="'url'"
                    data-vv-name="url"
                    :error-messages="errors.collect('url')"
                    :label="$t('organization.org_url')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-autocomplete
                    v-model="country_id"
                    v-validate="'required'"
                    :items="countries"
                    :error-messages="errors.collect('country_id')"
                    item-text="name"
                    item-value="id"
                    required
                    data-vv-name="country_id"
                    :label="$t('profile.profile.country')"
                  />
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-text-field
                    v-model="city"
                    data-vv-name="city"
                    :error-messages="errors.collect('city')"
                    :label="$t('organization.org_city')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3 mb-5>
                  <v-text-field
                    v-model="zip_code"
                    data-vv-name="zip_code"
                    :error-messages="errors.collect('zip_code')"
                    :label="$t('organization.org_zip_code')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-text-field
                    v-model="legal_document"
                    data-vv-name="legal_document"
                    :error-messages="errors.collect('legal_document')"
                    :label="$t('organization.org_legal_document')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-autocomplete
                    v-model="currency_id"
                    :items="currencies"
                    v-validate="'required'"
                    data-vv-name="currency_id"
                    :error-messages="errors.collect('currency_id')"
                    item-text="code"
                    required
                    item-value="id"
                    :label="$t('organization.org_currency')"
                  />
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-select
                    :items="[
                      'Instagram',
                      'Facebook',
                      'Twitter',
                      'LinkedIn',
                      'Web',
                      'Other'
                    ]"
                    v-model="source"
                    label="Source"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-autocomplete
                    :items="classifications"
                    data-vv-name="classification_id"
                    item-text="type"
                    item-value="id"
                    v-model="classification_id"
                    label="Clasificacion"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs5 offset-xs1>
          <v-card class="afrus-d-rounded-card mt-5">
            <v-card-title primary-title>
              <h5>
                {{ $t("organization.form.user_data") }}
              </h5>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-text-field
                    v-model="user_firstname"
                    v-validate="'required'"
                    data-vv-name="user_firstname"
                    :label="$t('profile.profile.people.firstname')"
                    required
                    :error-messages="errors.collect('user_firstname')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-text-field
                    v-model="user_lastname"
                    v-validate="'required'"
                    data-vv-name="user_lastname"
                    required
                    :error-messages="errors.collect('user_lastname')"
                    :label="$t('profile.profile.people.lastname')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-text-field
                    v-model="user_email"
                    v-validate="'required|email'"
                    data-vv-name="user_email"
                    :label="$t('login.email')"
                    required
                    :error-messages="errors.collect('user_email')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-text-field
                    v-model="user_password"
                    v-validate="'required'"
                    data-vv-name="user_password"
                    required
                    :error-messages="errors.collect('user_password')"
                    :label="$t('login.password')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-text-field
                    v-model="phone"
                    v-validate="'required'"
                    :error-messages="errors.collect('phone')"
                    data-vv-name="phone"
                    :mask="'phone'"
                    required
                    :label="$t('organization.table.org_phone')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5 offset-xs1>
                  <v-select
                    v-model="language_code"
                    v-validate="'required'"
                    :items="languages"
                    item-text="name"
                    item-value="code"
                    :error-messages="errors.collect('language_code')"
                    :label="$t('profile.profile.language')"
                    data-vv-name="language_code"
                    required
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs5 ml-3>
                  <v-autocomplete
                    v-model="time_zone"
                    v-validate="'required'"
                    :items="time_zones"
                    :label="$t('profile.profile.timezone')"
                    :error-messages="
                      errors.collect($t('profile.profile.timezone'))
                    "
                    :data-vv-name="$t('profile.profile.timezone')"
                    required
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <BaseInfoDialog
          v-if="infoDialog"
          :title="infoDialogTitle"
          :description="infoDialogDescription"
          closeText="Cerrar"
        />
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          absolute
          style="top: 64px"
        />
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import BaseToolbar from "@/components/BaseToolbar";
import BaseInfoDialog from "@/components/BaseInfoDialog";
import moment from "moment-timezone";
export default {
  components: {
    BaseToolbar,
    BaseInfoDialog
  },
  async created() {
    await this.getCurrencies();
    await this.getCountries();
    await this.getClassifications();
  },
  data: () => ({
    time_zones: moment.tz.names(),
    user_firstname: "",
    user_lastname: "",
    user_email: "",
    phone: "",
    name: "",
    url: "",
    city: "",
    country_id: "",
    currency_id: "",
    zip_code: "",
    legal_document: "",
    user_password: "",
    language_code: "",
    time_zone: "",
    width: "95%",
    infoDialog: false,
    infoDialogTitle: "",
    infoDialogDescription: "",
    isLoading: false,
    classification_id: "",
    source: ""
  }),
  methods: {
    ...mapActions({
      getCurrencies: "countries/getCurrencies",
      getCountries: "countries/getCountries",
      createOrganization: "organization/createOrganization",
      getClassifications: "organization/getClassifications"
    }),
    ...mapMutations({
      organizationDrawerNew: "organization/organizationDrawerNew"
    }),
    getWindowDimensions() {
      if (process.client) {
        this.width =
          window.innerWidth > 800 ? window.innerWidth * 0.5 : window.innerWidth;
      }
    },
    closeDrawerOrg() {
      this.organizationDrawerNew(false);
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    async save() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.isLoading = true;

        const payload = {
          first_name: this.user_firstname,
          last_name: this.user_lastname,
          email: this.user_email,
          phone: this.phone,
          organization_name: this.name,
          organization_url: this.url,
          organization_country: this.country_id,
          organization_currency: this.currency_id,
          organization_city: this.city,
          organization_zip_code: this.zip_code,
          organization_legal_document: this.legal_document,
          language_code: this.language_code,
          password: this.user_password,
          password_confirmation: this.user_password,
          time_zone: this.time_zone,
          classification_id: this.classification_id,
          source: this.source
        };

        this.createOrganization(payload)
          .then(
            res => {
              const { data } = res;
              const {
                createOrganizationSuccess,
                createAccountSuccess,
                activateModulesSuccess,
                createLeadToAfrusITSuccess,
                createAccountError,
                activateModulesError,
                addCustomerUserError,
                createLeadToAfrusITError
              } = data;

              if (createOrganizationSuccess) {
                this.$noty.success(this.$t("organization.success"));
              }
              if (createAccountSuccess) {
                this.$noty.success(
                  "Se ha activado una cuenta AWS exitosamente"
                );
              }

              if (activateModulesSuccess) {
                this.$noty.success("Se han activado los modulos exitosamente");
              }

              if (createLeadToAfrusITSuccess) {
                this.$noty.success(
                  "Se ha creado el lead hacia afrus IT con éxito"
                );
              }

              if (!createAccountSuccess) {
                this.$noty.error(
                  "No se ha podido crear la cuenta para la organizacion"
                );
              }

              if (!activateModulesSuccess) {
                this.$noty.error(
                  "Hubo un error al activar los modulos para la organizacion"
                );
              }

              if (!createLeadToAfrusITSuccess) {
                this.$noty.error(
                  "Hubo un error al crear el lead hacia afrus IT"
                );
              }

              this.isLoading = false;
              this.infoDialog = true;
              this.infoDialogTitle = "Activacion de Modulos Exitosa!";
              this.infoDialogDescription =
                "Se han activado los siguientes modulos: Amazon SES, Zapier, Essentials, Landing, Automation, Certificates ";
            },
            err => {
              const { data } = err.response;
              const {
                createOrganizationSuccess,
                createAccountSuccess,
                activateModulesSuccess,
                createLeadToAfrusITSuccess,
                createAccountError,
                activateModulesError,
                addCustomerUserError,
                createLeadToAfrusITError,
                msg,
                modules
              } = data;
              const {
                amazonModule,
                automationModule,
                certificationsModule,
                essentialsModule,
                landingModule,
                zapierModule
              } = modules;
              if (!createOrganizationSuccess) {
                this.$noty.error(this.$t("organization.error"));
                if (msg === "organization_already_exist") {
                  this.$noty.error(this.$t("general.error.organization_exist"));
                }

                if (msg === "user_already_exist") {
                  this.$noty.error(this.$t("general.error.user_exist"));
                }
              }

              if (!createAccountSuccess) {
                this.$noty.error(
                  "No se ha podido crear la cuenta para la organizacion"
                );
              }

              if (!activateModulesSuccess) {
                this.$noty.error(
                  "Hubo un error al activar los modulos para la organizacion"
                );
              }

              if (!createLeadToAfrusITSuccess) {
                this.$noty.error(
                  "Hubo un error al crear el lead hacia afrus IT"
                );
              }

              if (
                !essentialsModule ||
                !zapierModule ||
                !amazonModule ||
                !landingModule ||
                !automationModule ||
                !certificationsModule
              ) {
                this.isLoading = false;

                const essentials = !essentialsModule ? " Essentials " : "";
                const zapier = !zapierModule ? "- Zapier " : "";
                const amazon = !amazonModule ? "- Amazon " : "";
                const landing = !landingModule ? "- Landings " : "";
                const automation = !automationModule ? "- Automation " : "";
                const certifications = !certificationsModule
                  ? "- Certificates "
                  : "";
                this.infoDialogTitle =
                  "Hubo un error en la activacion de modulos";
                this.infoDialogDescription =
                  "Ha habido un error al activar los siguientes modulos: " +
                  essentials +
                  zapier +
                  amazon +
                  landing +
                  automation +
                  certifications;
                this.infoDialog = true;
              }
              this.$noty.error(this.$t("organization.messages.create.error"));
            }
          )
          .catch(() => {
            this.$noty.error(this.$t("organization.messages.create.error"));
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  },
  computed: {
    ...mapState({
      languages: ({ auth: { locales } }) => locales,
      currencies: ({ countries: { currencies } }) => currencies,
      countries: ({ countries: { countries } }) => countries,
      classifications: ({ organization: { classifications } }) =>
        classifications
    })
  }
};
</script>

<style></style>
